import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './component/Footer';
import { useCart } from "./context/CartContext";
import { getLocalData } from "./utils/localStorageHelper";
import api from "./api";

const BinIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" /><path d="M14 11v6" />
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
);

const HeartIcon = ({ filled }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
        fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
);

const ChevronDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const cartStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');

    .cart-page-wrapper {
        background: #f2f2f7;
        min-height: auto;
        font-family: 'Nunito', -apple-system, BlinkMacSystemFont, sans-serif;
    }

    /* ─── DESKTOP NAV STRIP ─── */
    .cart-desktop-nav {
        background: #fff;
        border-bottom: 1px solid #eee;
        padding: 0 40px;
    }
    .cart-desktop-nav-inner {
        max-width: 1200px; margin: 0 auto;
        display: flex; align-items: center; gap: 24px; height: 56px;
    }
    .cart-back-btn {
        background: none; border: none; cursor: pointer;
        display: flex; align-items: center; color: #1a1a1a; padding: 0; flex-shrink: 0;
    }
    .cart-nav-title {
        font-size: 16px; font-weight: 800; color: #1a1a1a;
        letter-spacing: 0.5px; flex-shrink: 0;
    }
    .cart-steps { display: flex; align-items: center; gap: 0; flex: 1; }
    .cart-step {
        display: flex; align-items: center; gap: 6px;
        font-size: 12.5px; font-weight: 600; color: #aaa; white-space: nowrap;
    }
    .cart-step.active { color: #2e7d32; }
    .cart-step-icon {
        width: 18px; height: 18px; border-radius: 50%;
        display: flex; align-items: center; justify-content: center;
        background: #ddd; flex-shrink: 0;
    }
    .cart-step.active .cart-step-icon { background: #2e7d32; color: #fff; }
    .cart-step-divider {
        flex: 1; min-width: 40px; height: 0;
        border-top: 2px dashed #ddd; margin: 0 6px;
    }

    /* ─── MOBILE NAV ─── */
    .cart-mobile-nav {
        display: none; background: #fff; padding: 14px 16px 0;
        border-bottom: 1px solid #eee; position: sticky; top: 0; z-index: 100;
    }
    .cart-mobile-nav .cart-nav-back-row {
        display: flex; align-items: center; gap: 10px; margin-bottom: 14px;
    }
    .cart-mobile-nav .cart-steps { padding-bottom: 14px; }

    /* ─── DESKTOP BODY LAYOUT ─── */
    .cart-desktop-body {
        max-width: 1200px; margin: 0 auto;
        padding: 32px 40px 60px;
        display: grid; grid-template-columns: 1fr 360px;
        gap: 28px; align-items: start;
    }

    /* ─── CASHBACK BANNER ─── */
    .cashback-banner {
        display: flex; align-items: center; gap: 10px;
        background: #e8f5e9; padding: 11px 16px; border-radius: 10px;
        margin-bottom: 16px; font-size: 13px; font-weight: 700; color: #2e7d32;
    }
    .cashback-icon {
        width: 32px; height: 32px; background: #fff; border-radius: 8px;
        display: flex; align-items: center; justify-content: center;
        flex-shrink: 0; box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    }

    /* ─── CART ITEM CARD ─── */
    .cart-item-card {
        background: #fff; border-radius: 16px; margin-bottom: 14px;
        overflow: hidden; box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        border: 1px solid rgba(0,0,0,0.04);
    }
    .cart-item-top { display: flex; padding: 16px; gap: 0; }
    .cart-item-img-wrap {
        width: 100px; height: 120px; border-radius: 10px;
        overflow: hidden; background: #f5f5f5; flex-shrink: 0; margin-right: 16px;
    }
    .cart-item-img-wrap img { width: 100%; height: 100%; object-fit: cover; }
    .cart-item-body {
        flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px;
    }
    .cart-item-name {
        font-size: 14px; font-weight: 800; color: #1a1a1a; line-height: 1.35;
        text-decoration: none; display: block; margin-bottom: 2px;
    }
    .cart-item-name:hover { color: #2e7d32; }

    /* ─── PRICE ROWS ─── */
    .cart-item-price-row {
        display: flex; align-items: baseline; gap: 8px; margin-top: 2px;
    }
    .cart-item-price { font-size: 17px; font-weight: 800; color: #1a1a1a; }
    .cart-item-unit-price {
        font-size: 12px; color: #888; font-weight: 600;
    }
    .cart-item-mrp {
        font-size: 12px; color: #aaa; text-decoration: line-through; font-weight: 500;
    }
    .cart-item-savings { font-size: 12px; color: #2e7d32; font-weight: 700; margin-top: 1px; }
    .cart-item-savings span { color: #2e7d32; font-weight: 800; }

    /* ─── QUANTITY BADGE ─── */
    .cart-item-qty-badge {
        display: inline-flex; align-items: center; gap: 4px;
        background: #f0f0f0; border-radius: 6px;
        padding: 2px 8px; font-size: 12px; font-weight: 700; color: #555;
        margin-top: 2px;
    }
    .cart-item-qty-badge span { color: #1a1a1a; font-weight: 800; }

    .cart-item-attrs {
        display: flex; gap: 20px; margin-top: 8px; padding-top: 8px;
        border-top: 1px solid #f0f0f0;
    }
    .cart-item-attr { font-size: 12px; color: #777; font-weight: 600; }
    .cart-item-attr strong { color: #1a1a1a; font-weight: 700; }
    .cart-qty-row { margin-top: 10px; }
    .qty-dropdown-btn {
        display: inline-flex; align-items: center; gap: 6px;
        background: #f5f5f5; border: 1.5px solid #e0e0e0; border-radius: 8px;
        padding: 7px 12px; font-size: 13px; font-weight: 700; color: #1a1a1a;
        cursor: pointer; font-family: 'Nunito', sans-serif; transition: border-color 0.2s;
    }
    .qty-dropdown-btn:hover { border-color: #aaa; }

    /* ─── ITEM ACTION BUTTONS ─── */
    .cart-item-actions { display: flex; border-top: 1px solid #f0f0f0; }
    .cart-action-btn {
        flex: 1; display: flex; align-items: center; justify-content: center;
        gap: 7px; padding: 12px; font-size: 13px; font-weight: 600; color: #666;
        background: none; border: none; cursor: pointer;
        font-family: 'Nunito', sans-serif; transition: background 0.15s, color 0.15s;
    }
    .cart-action-btn:first-child { border-right: 1px solid #f0f0f0; }
    .cart-action-btn.remove-btn:hover { background: #fff5f5; color: #e53935; }
    .cart-action-btn.wishlist-btn:hover { background: #fff0f5; color: #e91e63; }
    .cart-action-btn.wishlist-btn.wishlisted { color: #e91e63; }

    /* ─── EXTRA SAVINGS ─── */
    .extra-savings-section {
        background: #fff; border-radius: 16px; overflow: hidden;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        border: 1px solid rgba(0,0,0,0.04); margin-bottom: 14px;
    }
    .extra-savings-header {
        display: flex; align-items: center; justify-content: space-between;
        padding: 16px; cursor: pointer;
    }
    .extra-savings-title { font-size: 14px; font-weight: 800; color: #1a1a1a; }
    .extra-savings-body {
        background: #fffde7; padding: 12px 16px; border-top: 1px solid #fff9c4;
        font-size: 12.5px; font-weight: 700; color: #f57f17; text-align: center;
    }

    /* ─── ORDER SUMMARY CARD ─── */
    .order-summary-card {
        background: #fff; border-radius: 16px; padding: 20px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.06);
        border: 1px solid rgba(0,0,0,0.04); position: sticky; top: 80px;
    }
    .summary-title {
        font-size: 14px; font-weight: 800; color: #1a1a1a;
        margin-bottom: 16px; padding-bottom: 12px; border-bottom: 1.5px solid #f0f0f0;
    }
    .summary-row {
        display: flex; justify-content: space-between; align-items: center;
        padding: 9px 0; font-size: 13px; color: #555; border-bottom: 1px solid #f5f5f5;
    }
    .summary-row:last-of-type { border-bottom: none; }
    .summary-row .val { font-weight: 700; color: #1a1a1a; }
    .summary-row .val.green { color: #2e7d32; }
    .summary-total {
        display: flex; justify-content: space-between;
        padding: 14px 0 0; font-size: 15px; font-weight: 800; color: #1a1a1a;
        border-top: 1.5px solid #f0f0f0; margin-top: 4px;
    }
    .checkout-btn {
        width: 100%; background: #1a1a1a; color: #fff; border: none;
        border-radius: 10px; padding: 15px; font-size: 14px; font-weight: 800;
        letter-spacing: 1px; text-transform: uppercase; cursor: pointer;
        margin-top: 20px; font-family: 'Nunito', sans-serif;
        transition: background 0.2s, transform 0.15s;
    }
    .checkout-btn:hover { background: #333; transform: translateY(-1px); }
    .checkout-btn:active { transform: translateY(0); }
    .secure-note {
        display: flex; align-items: center; justify-content: center;
        gap: 5px; font-size: 11px; color: #bbb; margin-top: 12px; font-weight: 600;
    }

    /* ─── MOBILE PLACE ORDER BAR ─── */
    .place-order-bar {
        display: none; position: sticky; bottom: 0;
        background: #ceb256; padding: 16px; z-index: 50;
    }
    .place-order-btn {
        width: 100%; background: transparent; color: #fff; border: none;
        font-size: 15px; font-weight: 800; letter-spacing: 1.5px;
        text-transform: uppercase; cursor: pointer; font-family: 'Nunito', sans-serif;
    }

    /* ─── EMPTY CART ─── */
    .empty-cart-wrap { max-width: 1200px; margin: 0 auto; padding: 40px; }
    .empty-cart {
        display: flex; flex-direction: column; align-items: center;
        justify-content: center; padding: 80px 24px; text-align: center;
        background: #fff; border-radius: 16px; box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }
    .empty-cart-icon {
        width: 80px; height: 80px; border-radius: 50%; background: #f5f5f5;
        display: flex; align-items: center; justify-content: center; margin-bottom: 18px;
    }
    .empty-cart h3 { font-size: 20px; font-weight: 800; color: #1a1a1a; margin-bottom: 8px; }
    .empty-cart p { color: #aaa; font-size: 13px; margin-bottom: 24px; }
    .empty-cart .shop-link {
        background: #1a1a1a; color: #fff; padding: 14px 32px;
        border-radius: 12px; font-weight: 700; text-decoration: none; font-size: 14px;
    }

    /* ─── QTY BOTTOM SHEET ─── */
    .qty-overlay {
        position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 200;
        display: flex; align-items: flex-end; justify-content: center;
        animation: fadeInOv 0.15s ease;
    }
    @keyframes fadeInOv { from { opacity: 0 } to { opacity: 1 } }
    .qty-sheet {
        background: #fff; width: 100%; max-width: 480px;
        border-radius: 20px 20px 0 0; padding: 20px 0 40px;
        animation: slideUpSh 0.25s ease;
    }
    @keyframes slideUpSh { from { transform: translateY(40px) } to { transform: translateY(0) } }
    .qty-sheet-handle {
        width: 40px; height: 4px; background: #ddd; border-radius: 2px; margin: 0 auto 16px;
    }
    .qty-sheet-title {
        font-size: 14px; font-weight: 800; color: #1a1a1a;
        padding: 0 20px 12px; border-bottom: 1px solid #f0f0f0;
    }
    .qty-sheet-option {
        padding: 14px 20px; font-size: 14px; font-weight: 600; color: #333;
        cursor: pointer; transition: background 0.15s;
        display: flex; justify-content: space-between; align-items: center;
    }
    .qty-sheet-option:hover { background: #f8f8f8; }
    .qty-sheet-option.selected { color: #2e7d32; font-weight: 800; }

    /* ─── SWEETALERT2 CUSTOM STYLE ─── */
    .swal-cart-popup {
        border-radius: 20px !important;
        font-family: 'Nunito', sans-serif !important;
        padding: 28px !important;
    }
    .swal-cart-title {
        font-size: 18px !important;
        font-weight: 800 !important;
        color: #1a1a1a !important;
    }
    .swal-cart-text {
        font-size: 13.5px !important;
        color: #777 !important;
    }
    .swal-confirm-btn {
        background: #e53935 !important;
        border-radius: 10px !important;
        font-weight: 700 !important;
        font-size: 13px !important;
        padding: 10px 24px !important;
        font-family: 'Nunito', sans-serif !important;
    }
    .swal-cancel-btn {
        background: #f5f5f5 !important;
        color: #555 !important;
        border-radius: 10px !important;
        font-weight: 700 !important;
        font-size: 13px !important;
        padding: 10px 24px !important;
        font-family: 'Nunito', sans-serif !important;
    }

    /* ─── RESPONSIVE ─── */
    @media (max-width: 900px) {
        .cart-desktop-nav { display: none; }
        .cart-mobile-nav { display: block; }
        .cart-desktop-body { display: block; padding: 12px 0 100px; }
        .cart-desktop-body .left-col { padding: 0 12px; }
        .cart-desktop-body .right-col { padding: 0 12px; position: static; }
        .order-summary-card { position: static; margin-top: 4px; }
        .checkout-btn { display: none; }
        .place-order-bar { display: block; }
    }
    @media (min-width: 901px) {
        .cart-mobile-nav { display: none; }
        .cart-desktop-nav { display: block; }
        .place-order-bar { display: none; }
    }
`;

// ─────────────────────────────────────────────
// KEY FIX: Generate a unique key per cart item
// combining productId + color + size so that
// quantity updates NEVER bleed across variants.
// ─────────────────────────────────────────────
const getVariantKey = (item) => {
    const id = item._id || item.id || '';
    const color = item?.variant?.color?.name || 'no-color';
    const size = item?.variant?.size || 'no-size';
    return `${id}__${color}__${size}`;
};

const AddCart = () => {
    const [subtotal, setSubtotal] = useState(0);
    const cartProducts = getLocalData("cart");
    const navigate = useNavigate();
    const { cart, removeFromCart, clearCart, updateQuantity } = useCart();

    // Store the variant key of the open sheet, not the whole item object.
    // This prevents stale closure / reference issues when cart re-renders.
    const [qtySheetKey, setQtySheetKey] = useState(null);

    // ── Wishlist state ──
    const [wishlistedProducts, setWishlistedProducts] = useState({});

    // Derive the live item from cart using the stored key each render
    const qtySheet = qtySheetKey
        ? cart.find((i) => getVariantKey(i) === qtySheetKey) ?? null
        : null;

    const handleCheckout = () => {
        const token = localStorage.getItem("userData");
        if (token) {
            navigate("/check-out", {
                state: { token, products: cartProducts, singleProduct: "no", singleProductId: "" },
            });
        } else {
            navigate("/user-login");
        }
    };

    // ── Remove with SweetAlert2 confirmation ──
    const handleRemove = (item) => {
        Swal.fire({
            title: "Remove item?",
            text: `Remove "${item.name}" from your cart?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Remove",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            customClass: {
                popup: "swal-cart-popup",
                title: "swal-cart-title",
                htmlContainer: "swal-cart-text",
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn",
            },
            buttonsStyling: true,
        }).then((result) => {
            if (result.isConfirmed) {
                removeFromCart(item, item?.variant?.color?.name, item?.variant?.size);
                toast.info("Item removed from cart", {
                    position: "top-right",
                    autoClose: 2000,
                    theme: "dark",
                });
            }
        });
    };

    // ── Add / Remove Wishlist ──
    const addWishList = async (product) => {
        const storedData = localStorage.getItem("userData");
        const token = storedData ? JSON.parse(storedData).token : null;

        if (!token) {
            setWishlistedProducts({});
            navigate("/user-login");
            return;
        }

        const isWishlisted = !!wishlistedProducts[product._id];

        try {
            await api.put(
                "/user/add-wishlist",
                { productId: product._id, product },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setWishlistedProducts((prev) => ({
                ...prev,
                [product._id]: !isWishlisted,
            }));

            if (isWishlisted) {
                toast.info("Removed from wishlist", { position: "top-right", autoClose: 2000, theme: "dark" });
            } else {
                toast.success("Added to wishlist ❤️", { position: "top-right", autoClose: 2000, theme: "dark" });
            }
        } catch (err) {
            console.error("Error updating wishlist:", err);
            toast.error("Failed to update wishlist. Please try again.", { position: "top-right", autoClose: 3000, theme: "dark" });
        }
    };

    // ── Recalculate subtotal whenever cart changes ──
    useEffect(() => {
        const newSubtotal = cart.reduce((acc, item) => {
            return acc + (item.variant?.discountedPrice || 0) * item.quantity;
        }, 0);
        setSubtotal(newSubtotal);
    }, [cart]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    const totalItems = cart.reduce((a, i) => a + i.quantity, 0);
    const totalMRP = cart.reduce((acc, item) => acc + (item.variant?.originalPrice || 0) * item.quantity, 0);
    const totalDiscount = totalMRP - subtotal;

    const StepsBar = () => (
        <div className="cart-steps">
            <div className="cart-step active">
                <div className="cart-step-icon">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="3.5" strokeLinecap="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>
                Cart
            </div>
            <div className="cart-step-divider" />
            <div className="cart-step">
                <div className="cart-step-icon" />
                Address
            </div>
            <div className="cart-step-divider" />
            <div className="cart-step">
                <div className="cart-step-icon" />
                Payment
            </div>
        </div>
    );

    const renderCartItems = () => (
        <>
            {/* Cashback Banner */}
            <div className="cashback-banner">
                <div className="cashback-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                        fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round">
                        <rect x="1" y="4" width="22" height="16" rx="2" />
                        <line x1="1" y1="10" x2="23" y2="10" />
                    </svg>
                </div>
                10% Cashback Unlocked - No Coupon Required
            </div>

            {/* Items */}
            {cart.map((item) => {
                const variantKey = getVariantKey(item);          // ← unique per variant
                const unitPrice = item.variant?.discountedPrice || 0;
                const unitMRP = item.variant?.originalPrice || 0;
                const qty = item.quantity;
                const totalPrice = unitPrice * qty;
                const totalMRPItem = unitMRP * qty;
                const savings = totalMRPItem - totalPrice;
                const isWishlisted = !!wishlistedProducts[item._id || item.id];

                const productForWishlist = {
                    _id: item._id || item.id,
                    name: item.name,
                    variant: item.variant,
                    category: item.category,
                };

                return (
                    <div
                        className="cart-item-card"
                        key={variantKey}   // ← use composite key here too
                    >
                        <div className="cart-item-top">
                            <Link to={`/product-details/${item.id}`} state={{ items: item }}
                                className="cart-item-img-wrap">
                                <img
                                    src={item?.variant?.images?.[0] ?? "https://via.placeholder.com/200?text=No+Image"}
                                    alt={item.name}
                                />
                            </Link>
                            <div className="cart-item-body">
                                <Link className="cart-item-name"
                                    to={`/product-details/${item.id}`} state={{ items: item }}>
                                    {item.name}
                                </Link>

                                <div className="cart-item-price-row">
                                    <span className="cart-item-price">₹{totalPrice.toFixed(0)}</span>
                                    {unitMRP > unitPrice && (
                                        <span className="cart-item-mrp">₹{totalMRPItem.toFixed(0)}</span>
                                    )}
                                </div>

                                {qty > 1 && (
                                    <div className="cart-item-unit-price">
                                        ₹{unitPrice.toFixed(0)} × {qty} pcs
                                    </div>
                                )}

                                {savings > 0 && (
                                    <div className="cart-item-savings">
                                        You Save <span>₹{savings.toFixed(2)}</span>
                                    </div>
                                )}

                                <div className="cart-item-attrs">
                                    {item?.variant?.color?.name && (
                                        <div className="cart-item-attr">
                                            Color : <strong>{item.variant.color.name}</strong>
                                        </div>
                                    )}
                                    {item?.variant?.size && (
                                        <div className="cart-item-attr">
                                            Size : <strong>{item.variant.size}</strong>
                                        </div>
                                    )}
                                </div>

                                {/* ── Qty selector: open sheet using variantKey ── */}
                                <div className="cart-qty-row">
                                    <button
                                        className="qty-dropdown-btn"
                                        onClick={() => setQtySheetKey(variantKey)}  // ← store key, not item
                                    >
                                        Qty: {qty} <ChevronDown />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="cart-item-actions">
                            <button className="cart-action-btn remove-btn"
                                onClick={() => handleRemove(item)}>
                                <BinIcon /> Remove
                            </button>
                            <button
                                className={`cart-action-btn wishlist-btn ${isWishlisted ? 'wishlisted' : ''}`}
                                onClick={() => addWishList(productForWishlist)}>
                                <HeartIcon filled={isWishlisted} />
                                {isWishlisted ? 'Wishlisted' : 'Move to Wishlist'}
                            </button>
                        </div>
                    </div>
                );
            })}

            {/* Extra Savings */}
            <div className="extra-savings-section">
                <div className="extra-savings-header">
                    <span className="extra-savings-title">Extra Savings</span>
                    <ChevronDown />
                </div>
                <div className="extra-savings-body">
                    Bonus Discount Available at Payment Step
                </div>
            </div>
        </>
    );

    const OrderSummary = () => (
        <div className="order-summary-card">
            <div className="summary-title">
                Price Details ({totalItems} {totalItems === 1 ? 'Item' : 'Items'})
            </div>
            <div className="summary-row">
                <span>Total MRP</span>
                <span className="val">₹{totalMRP.toFixed(2)}</span>
            </div>
            <div className="summary-row">
                <span>Discount on MRP</span>
                <span className="val green">−₹{totalDiscount.toFixed(2)}</span>
            </div>
            <div className="summary-row">
                <span>Shipping Fee</span>
                <span className="val green">FREE</span>
            </div>
            <div className="summary-row">
                <span>Tax</span>
                <span className="val" style={{ fontSize: '12px', color: '#999' }}>Included</span>
            </div>
            <div className="summary-total">
                <span>Total Amount</span>
                <span>₹{subtotal.toFixed(2)}</span>
            </div>
            <button className="checkout-btn" onClick={handleCheckout}>
                PLACE ORDER
            </button>
            <div className="secure-note">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="none"
                    stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Safe & Secure Payments
            </div>
        </div>
    );

    return (
        <>
            <style>{cartStyles}</style>

            <div className="cart-page-wrapper">

                {/* ── DESKTOP NAV ── */}
                <div className="cart-desktop-nav">
                    <div className="cart-desktop-nav-inner">
                        <button className="cart-back-btn" onClick={() => navigate(-1)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
                                stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                <path d="M19 12H5M12 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <span className="cart-nav-title">CART</span>
                        <StepsBar />
                    </div>
                </div>

                {/* ── MOBILE NAV ── */}
                <div className="cart-mobile-nav">
                    <div className="cart-nav-back-row">
                        <button className="cart-back-btn" onClick={() => navigate(-1)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none"
                                stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                <path d="M19 12H5M12 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <span className="cart-nav-title">CART</span>
                    </div>
                    <StepsBar />
                </div>

                {/* ── BODY ── */}
                {cart.length === 0 ? (
                    <div className="empty-cart-wrap">
                        <div className="empty-cart">
                            <div className="empty-cart-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38"
                                    fill="none" stroke="#bbb" strokeWidth="1.5" viewBox="0 0 24 24">
                                    <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
                                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                                </svg>
                            </div>
                            <h3>Your cart is empty</h3>
                            <p>Looks like you haven't added anything yet.</p>
                            <Link to="/" className="shop-link">Explore Products</Link>
                        </div>
                    </div>
                ) : (
                    <div className="cart-desktop-body">
                        <div className="left-col">{renderCartItems()}</div>
                        <div className="right-col"><OrderSummary /></div>
                    </div>
                )}

                {/* MOBILE STICKY PLACE ORDER */}
                {cart.length > 0 && (
                    <div className="place-order-bar">
                        <button className="place-order-btn" onClick={handleCheckout}>
                            PLACE ORDER
                        </button>
                    </div>
                )}
            </div>

            {/* QTY BOTTOM SHEET */}
            {qtySheet && (
                <div className="qty-overlay" onClick={() => setQtySheetKey(null)}>
                    <div className="qty-sheet" onClick={(e) => e.stopPropagation()}>
                        <div className="qty-sheet-handle" />
                        <div className="qty-sheet-title">Select Quantity</div>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => {
                            const availableStock = qtySheet?.variant?.stock ?? 10;
                            const isDisabled = n > availableStock;
                            return (
                                <div
                                    key={n}
                                    className={`qty-sheet-option ${qtySheet.quantity === n ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                    style={isDisabled ? { opacity: 0.35, cursor: 'not-allowed', pointerEvents: 'none' } : {}}
                                    onClick={() => {
                                        if (isDisabled) return;
                                        // ─────────────────────────────────────────────
                                        // KEY FIX: pass exact color + size from the
                                        // live qtySheet item so CartContext can match
                                        // the ONE variant and not all siblings.
                                        // ─────────────────────────────────────────────
                                        updateQuantity(
                                            qtySheet,
                                            qtySheet?.variant?.color?.name,
                                            qtySheet?.variant?.size,
                                            n
                                        );
                                        setQtySheetKey(null);
                                    }}
                                >
                                    {n}
                                    {isDisabled
                                        ? <span style={{ fontSize: '11px', color: '#bbb', fontWeight: 600 }}>Out of stock</span>
                                        : qtySheet.quantity === n && (
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                                                <polyline points="20 6 9 17 4 12" />
                                            </svg>
                                        )
                                    }
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            <ToastContainer
                position="top-right"
                autoClose={2500}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover
                theme="dark"
            />

            <Footer />
        </>
    );
};

export default AddCart;